<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Contact
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.epri"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="email"
            hint="primary email"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.esec"
            :rules="mustBeLessThanSmallNotRequired"
            prepend-icon="mark_email_unread"
            hint="secondary email"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.ppri"
            :rules="mustBeMobilePhoneNumberAus"
            prepend-icon="smartphone"
            :mask="phonemask"
            hint="mobile phone"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.psec"
            :rules="mustBeLessThanSmallNotRequired"
            prepend-icon="call"
            hint="alt. phone"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Location
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.lcountry"
            prepend-icon="public"
            hint="country"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <!-- <div class="ml-2"> -->
            <v-select
              :change="updateFormChar()"
              v-model="state"
              :label="localForm.lstate"
              :items="locationState"
              color="wplblue0"
              prepend-icon="image"
              hint="state"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.lcity"
            prepend-icon="location_city"
            hint="city / suburb"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.lpost"
            prepend-icon="email"
            hint="post code"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12>
            <v-text-field
            v-model="localForm.ladd"
            prepend-icon="home"
            hint="address"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import selectLocation from "@/data/options/mixins/selectLocation.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
// import TransitionsStage from "@/support/transitions/components/TransitionsStage";
export default {
  data() {
    return {
      valid: true,
      phonemask: "0### ### ###",
      localForm: {
        epri: "",
        esec: "",
        ppri: "",
        psec: "",
        lcountry: "",
        lstate: "",
        lcity: "",
        lpost: "",
        ladd: ""
      },
      orgForm: {
        epri: "",
        esec: "",
        ppri: "",
        psec: "",
        lcountry: "",
        lstate: "",
        lcity: "",
        lpost: "",
        ladd: ""
      },
      state: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    state() {
      this.localForm.lstate = this.state;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.epri = this.getUser.char.epri;
    this.localForm.esec = this.getUser.char.esec;
    this.localForm.ppri = this.getUser.char.ppri;
    this.localForm.psec = this.getUser.char.psec;
    this.localForm.lcountry = this.getUser.char.lcountry;
    this.localForm.lstate = this.getUser.char.lstate;
    this.localForm.lcity = this.getUser.char.lcity;
    this.localForm.lpost = this.getUser.char.lpost;
    this.localForm.ladd = this.getUser.char.ladd;

    this.orgForm.epri = this.getUser.char.epri;
    this.orgForm.esec = this.getUser.char.esec;
    this.orgForm.ppri = this.getUser.char.ppri;
    this.orgForm.psec = this.getUser.char.psec;
    this.orgForm.lcountry = this.getUser.char.lcountry;
    this.orgForm.lstate = this.getUser.char.lstate;
    this.orgForm.lcity = this.getUser.char.lcity;
    this.orgForm.lpost = this.getUser.char.lpost;
    this.orgForm.ladd = this.getUser.char.ladd;
  },
  mixins: [docRevsModFunctions, ruleTextfield, apptheme, selectLocation],
  components: {
    // TransitionsStage
  },
  computed: {
    ...mapGetters(["getDetailBasic", "getDetailChar"]),
    userStatus() {
      let status = null;
      if (this.getUserBasic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.esec !== this.orgForm.esec &&
        this.localForm.esec !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.esec = this.localForm.esec;
        // basic
        char.esec = this.localForm.esec;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.54, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.ppri !== this.orgForm.ppri &&
        this.localForm.ppri !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ppri = this.localForm.ppri;
        // basic
        char.ppri = this.localForm.ppri;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.54, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.psec !== this.orgForm.psec &&
        this.localForm.psec !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.psec = this.localForm.psec;
        // basic
        char.psec = this.localForm.psec;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.54, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.lstate !== this.orgForm.lstate) {
        // after the change re-assign new Local to Org
        this.orgForm.lstate = this.localForm.lstate;
        // basic
        char.lstate = this.localForm.lstate;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.54, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.lcity !== this.orgForm.lcity &&
        this.localForm.lcity !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.lcity = this.localForm.lcity;
        // basic
        char.lcity = this.localForm.lcity;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.54, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.lpost !== this.orgForm.lpost &&
        this.localForm.lpost !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.lpost = this.localForm.lpost;
        // basic
        char.lpost = this.localForm.lpost;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.54, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.ladd !== this.orgForm.ladd &&
        this.localForm.ladd !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ladd = this.localForm.ladd;
        // basic
        char.ladd = this.localForm.ladd;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.54, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.state !== this.orgForm.state) {
        this.orgForm.state = this.localForm.state;
        char.lstate = this.localForm.lstate;
        this.$store.dispatch("changeDetailChar", char);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(4.54, 8); // business rev
      }
    }
  }
};
</script>
